import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductsByContainer } from "../../features/freezerSlice";
import AddProductModal from "../addProductModal/AddProductModal";
import EditProductModal from "../editProductModal/EditProductModal";
import styles from "./freezer.module.scss";

// Composant ProductCard
const ProductCard = ({ product }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleClick = () => {
    setIsEditModalOpen(true);
  };

  return (
    <>
      <div
        className={`${styles.productCard} ${
          styles[`category-${product.category}`]
        }`}
        onClick={handleClick}
        role="button"
        tabIndex={0}
      >
        <div className={styles.productHeader}>
          <h3>{product.name}</h3>
          <span className={styles.units}>{product.quantity} unité(s)</span>
        </div>
        <div className={styles.productDetails}>
          {product.details?.weight > 0 && (
            <span className={styles.weight}>{product.details.weight}g</span>
          )}
          {product.details?.portions > 1 && (
            <span className={styles.portions}>
              {product.details.portions} portions
            </span>
          )}
        </div>
        <div className={styles.productDates}>
          {product.details?.freezeDate && (
            <span className={styles.freezeDate}>
              Congelé le: {formatDate(product.details.freezeDate)}
            </span>
          )}
          {product.details?.dlc && (
            <span className={styles.dlc}>
              DLC: {formatDate(product.details.dlc)}
            </span>
          )}
        </div>
        {product.details?.additionalDetails && (
          <p className={styles.details}>{product.details.additionalDetails}</p>
        )}
      </div>

      {isEditModalOpen && (
        <EditProductModal
          product={product}
          onClose={() => setIsEditModalOpen(false)}
        />
      )}
    </>
  );
};

const Freezer = () => {
  const dispatch = useDispatch();
  const productsByContainer = useSelector(
    (state) => state.freezer.productsByContainer
  );
  const loading = useSelector((state) => state.freezer.loading);
  const error = useSelector((state) => state.freezer.error);

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedContainer, setSelectedContainer] = useState(null);

  const containers = [
    { id: 1, name: "Box 1" },
    { id: 2, name: "Box 2" },
    { id: 3, name: "Box 3" },
    { id: 4, name: "Box 4" },
    { id: 5, name: "Box 5" },
    { id: 6, name: "Box 6" },
  ];

  // Charger les produits au montage
  useEffect(() => {
    containers.forEach((container) => {
      dispatch(fetchProductsByContainer(container.id));
    });
  }, [dispatch]);

  const handleAddProduct = (containerId) => {
    setSelectedContainer(containerId);
    setIsAddModalOpen(true);
  };

  return (
    <div className={styles.freezerPage}>
      <h1>Freezer</h1>

      <div className={styles.containersGrid}>
        {containers.map((container) => (
          <section key={container.id} className={styles.containerSection}>
            <h2>{container.name}</h2>
            <button
              className={styles.addProductBtn}
              onClick={() => handleAddProduct(container.id)}
            >
              Add Prod
            </button>

            <div className={styles.productsArea}>
              {productsByContainer[container.id]?.map((product) => (
                <ProductCard key={product._id} product={product} />
              ))}
            </div>
          </section>
        ))}
      </div>

      {isAddModalOpen && (
        <AddProductModal
          containerId={selectedContainer}
          onClose={() => setIsAddModalOpen(false)}
        />
      )}
    </div>
  );
};

export default Freezer;
